import { getDataWithName, removeUndefineds, removeSlashesFromName, decorateWithTimestampsForFirestore } from './FirestoreUtils'

export default class DriverService {
  constructor (orgRef) {
    this.drivers = orgRef.collection(`drivers`)
  }
  async getDriver (name) {
    let doc = await this.drivers.doc(name).get()
    return getDataWithName(doc)
  }
  async getDrivers () {
    let querySnapshot = await this.drivers.get()
    let drivers = {}
    querySnapshot.forEach(doc => { drivers[doc.id] = getDataWithName(doc) })
    return drivers
  }
  async addDriver (driver) {
    driver.name = removeSlashesFromName(driver.name)
    removeUndefineds(driver)
    decorateWithTimestampsForFirestore(driver)
    let driverToSave = Object.assign({}, driver)
    delete driverToSave.name
    await this.drivers.doc(driver.name).set(driverToSave, { merge: true })
    return driver
  }
  async deleteDriver (name) {
    return this.drivers.doc(name).delete()
  }
}
